import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { NotificationVM, INotificationProps } from './NotificationVM';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import './notification.scss';

const NotificationComponent = (props: INotificationProps) => {
  const vm = useRef(new NotificationVM(props)).current;
  // Shows Notification when it receives a new timestamp
  useEffect(() => {
    vm.setHidden(props.hidden);
  }, [props.timestamp, props.hidden]);

  return (
    <div role="alert" aria-live="polite">
      <div className={`notification-container ` + vm.getClass(props.type)} hidden={vm.hidden}>
        <div className="row">
          <div className="col-2 notification-icon">
            <Icon path={vm.getIconPath(props.type)} title="" size={2} color={vm.getIconColor(props.type)} />
          </div>
          <div className="col-10">
            <div className="notification" aria-hidden={vm.hidden}>
              <div className="notification-hd">
                <button
                  className="notification-close"
                  aria-label="Close Notification button"
                  onClick={() => {
                    vm.setHidden(true);
                  }}
                >
                  <Icon path={mdiClose} title="" size={1} color={vm.getIconColor(props.type)} />
                </button>
                <h2 className="notification-title">
                  <strong>{props.header || vm.getDefaultHeader(props.type)}</strong>
                </h2>
              </div>
              <div className="notification-bd">
                <p>{props.message}</p>
                {React.Children.map(props.children, (child) => {
                  return child;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Notification = observer(NotificationComponent);
